"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PollLearner = require("./PollLearner.style");

var _DarkText = _interopRequireDefault(require("../../../DarkText"));

var _DarkRadio = _interopRequireDefault(require("../../../DarkRadio"));

var _DarkButton = _interopRequireDefault(require("../../../Button/DarkButton"));

var PollLearner =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PollLearner, _PureComponent);

  function PollLearner() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, PollLearner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(PollLearner)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderOption", function (option) {
      var _this$props = _this.props,
          selectedOptionId = _this$props.selectedOptionId,
          onSelection = _this$props.onSelection;
      var imageUrl = option.imageUrl,
          optionText = option.optionText;

      var optionLabel = _react.default.createElement("span", {
        className: "text-option"
      }, optionText);

      if (imageUrl) {
        optionLabel = _react.default.createElement("div", {
          className: "image-option-wrapper"
        }, _react.default.createElement("img", {
          src: imageUrl,
          alt: optionText,
          className: "image-option"
        }), optionLabel);
      }

      return _react.default.createElement(_DarkRadio.default, {
        name: option.optionText,
        value: option.optionId,
        label: optionLabel,
        onChange: onSelection,
        className: "option-wrapper",
        checked: selectedOptionId === option.optionId
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "submitClickHandler", function (event) {
      event.preventDefault();

      _this.props.onSubmit();
    });
    return _this;
  }

  (0, _createClass2.default)(PollLearner, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          poll = _this$props2.poll;
      return _react.default.createElement("form", {
        className: (0, _classnames.default)(_PollLearner.PollLearnerWrapper, className),
        onSubmit: this.submitClickHandler
      }, _react.default.createElement(_DarkText.default, {
        color: "zinc",
        uppercase: true
      }, "Poll"), _react.default.createElement(_DarkText.default, {
        className: "question-text",
        color: "silver",
        fontSize: 26
      }, poll.questionText), poll.options.map(this.renderOption), _react.default.createElement(_DarkButton.default, {
        type: "submit"
      }, "Submit"));
    }
  }]);
  return PollLearner;
}(_react.PureComponent);

PollLearner.defaultProps = {
  selectedOptionId: null,
  className: ''
};
PollLearner.propTypes = {
  className: _propTypes.default.string,
  poll: _propTypes.default.object.isRequired,
  selectedOptionId: _propTypes.default.number,
  onSelection: _propTypes.default.func.isRequired,
  onSubmit: _propTypes.default.func.isRequired
};
var _default = PollLearner;
exports.default = _default;